import React from 'react';
import {
    Popover, Button, ButtonToolbar, OverlayTrigger, Tooltip
} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { MoreVertical, Eye, Pencil, Trash2, Info, CheckCircle } from 'lucide-react';
import cx from 'classnames';

import cs from '../../components/commonStyle.css';
import s from './CommonTable.css';
import Link from '../../components/Link';
import messages from '../../locale/messages';

class TableAction extends React.Component {

    render() {
        const { onClickEdit, onClickDelete, showEdit, showDelete, showView, link, newLink, editNewLink, editLink, editAction } = this.props;
        const { payoutDefaultLoader, payoutVerifyLoader, index, setDefaultPayout, verifyPayout, item } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <ButtonToolbar>
                    <OverlayTrigger
                        placement="bottom"
                        rootClose={true}
                        trigger="click"
                        adaptivePosition="false"
                        overlay={(
                            <Popover positionLeft={200}
                                positionTop={50} placement="bottom">
                                {showView && link &&
                                    <Link to={link} className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                        <Eye size={16} style={{ marginRight: 8 }} />
                                        <span>{formatMessage(messages.viewLabel)}</span>
                                    </Link>
                                }
                                {showView && newLink &&
                                    <a href={newLink} target="_blank" className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                        <Eye size={16} style={{ marginRight: 8 }} />
                                        <span>{formatMessage(messages.viewLabel)}</span>
                                    </a>
                                }
                                {showEdit && onClickEdit && <Button onClick={onClickEdit} className={cx(cs.dFlex, cs.tabelDropDownBtn, cs.fontWeightBold, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                    <Pencil size={16} style={{ marginRight: 8 }} />
                                    <span>{formatMessage(messages.editLabel)}</span>
                                </Button>}
                                {
                                    showEdit && editNewLink && <a href={editNewLink} target="_blank" className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                        <Pencil size={16} style={{ marginRight: 8 }} />
                                        <span>{formatMessage(messages.editLabel)}</span>
                                    </a>
                                }
                                {
                                    showEdit && editLink && <Link to={editLink} className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                        <Pencil size={16} style={{ marginRight: 8 }} />
                                        <span>{formatMessage(messages.editLabel)}</span>
                                    </Link>
                                }
                                {
                                    showEdit && editAction && <Link noLink onClick={editAction} className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', 'wordBreak', cs.alignItemBaseline)}>
                                        <Pencil size={16} style={{ marginRight: 8 }} />
                                        <span>{formatMessage(messages.editLabel)}</span>
                                    </Link>
                                }
                                {
                                    item && <> {
                                        !item.default && item.isVerified && <a
                                            className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', cs.popoverPayout, 'wordBreak', cs.alignItemBaseline)}
                                            onClick={() => {
                                                if (!payoutDefaultLoader) {
                                                    setDefaultPayout(item.id)
                                                }
                                                document && document.body.click();
                                            }}
                                        >
                                            {formatMessage(messages.setDefault)}
                                        </a>
                                    }
                                        {
                                            !item.default && !item.isVerified && item.methodId === 2 && <a
                                                href='javascript:void(0)'
                                                onClick={() => {
                                                    if (!payoutVerifyLoader) {
                                                        verifyPayout(item.payEmail, item.userId);
                                                    }
                                                    document && document.body.click();
                                                }}
                                                className={cx(cs.dFlex, cs.noTextDecration, cs.commonMediumText, cs.fontWeightBold, cs.siteTextColor, 'popoverContentPadding', cs.popoverPayout)}
                                            >
                                                {formatMessage(messages.payoutVerify)}
                                                <OverlayTrigger
                                                    overlay={<Tooltip id={'tooltip' + index}><FormattedMessage {...messages.payoutVerifyStripeInfo} /></Tooltip>}
                                                    placement='top'
                                                >
                                                    <span style={{ marginLeft: 4 }}>
                                                        <Info size={14} />
                                                    </span>
                                                </OverlayTrigger>
                                            </a>
                                        }
                                    </>
                                }

                                {showDelete && <Button type='button' onClick={() => {
                                    onClickDelete();
                                    document && document.body.click();
                                }}
                                    className={cx(cs.dFlex, cs.tabelDropDownBtn, cs.fontWeightBold, 'popoverContentPadding', cs.popoverPayout)}>
                                    {!item && <Trash2 size={16} style={{ marginRight: 8, color: '#DC2626' }} />}
                                    <span>{item ? formatMessage(messages.remove) : formatMessage(messages.delete)}</span>
                                </Button>}
                            </Popover>
                        )}>
                        <Button className={cx(cs.tabelDropDownBtn, s.rowActionBtn)}>
                            <MoreVertical size={18} />
                        </Button>
                    </OverlayTrigger>
                </ButtonToolbar>
            </div>
        );
    }
}


export default injectIntl(withStyles(s, cs)(TableAction));